"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var framesync_1 = require("framesync");

var action_1 = require("../../action");

var calc_1 = require("../../calc");

var listen_1 = require("../listen");

var utils_1 = require("../pointer/utils");

var points = [utils_1.defaultPointerPos()];
var isTouchDevice = false;

if (typeof document !== 'undefined') {
  var updatePointsLocation = function updatePointsLocation(_a) {
    var touches = _a.touches;
    isTouchDevice = true;
    var numTouches = touches.length;
    points.length = 0;

    for (var i = 0; i < numTouches; i++) {
      var thisTouch = touches[i];
      points.push(utils_1.eventToPoint(thisTouch));
    }
  };

  listen_1.default(document, 'touchstart touchmove', true).start(updatePointsLocation);
}

var multitouch = function multitouch(_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.preventDefault,
      preventDefault = _c === void 0 ? true : _c,
      _d = _b.scale,
      scale = _d === void 0 ? 1.0 : _d,
      _e = _b.rotate,
      rotate = _e === void 0 ? 0.0 : _e;

  return action_1.default(function (_a) {
    var update = _a.update;
    var output = {
      touches: points,
      scale: scale,
      rotate: rotate
    };
    var initialDistance = 0.0;
    var initialRotation = 0.0;
    var isGesture = points.length > 1;

    if (isGesture) {
      var firstTouch = points[0],
          secondTouch = points[1];
      initialDistance = calc_1.distance(firstTouch, secondTouch);
      initialRotation = calc_1.angle(firstTouch, secondTouch);
    }

    var updatePoint = function updatePoint() {
      if (isGesture) {
        var firstTouch = points[0],
            secondTouch = points[1];
        var newDistance = calc_1.distance(firstTouch, secondTouch);
        var newRotation = calc_1.angle(firstTouch, secondTouch);
        output.scale = scale * (newDistance / initialDistance);
        output.rotate = rotate + (newRotation - initialRotation);
      }

      update(output);
    };

    var onMove = function onMove(e) {
      if (preventDefault || e.touches.length > 1) e.preventDefault();
      framesync_1.onFrameUpdate(updatePoint);
    };

    var updateOnMove = listen_1.default(document, 'touchmove', {
      passive: !preventDefault
    }).start(onMove);
    if (isTouchDevice) framesync_1.onFrameUpdate(updatePoint);
    return {
      stop: function stop() {
        framesync_1.cancelOnFrameUpdate(updatePoint);
        updateOnMove.stop();
      }
    };
  });
};

exports.default = multitouch;

exports.getIsTouchDevice = function () {
  return isTouchDevice;
};